import {
    useEffect,
    useLayoutEffect,
} from 'react';

const useIsomorphicLayoutEffect = __CLIENT__
    ? useLayoutEffect
    : useEffect;

// Ensure the name used in components is useLayoutEffect
export default useIsomorphicLayoutEffect;
